<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Portlet from '@src/components/portlet'
import AnalysisService from '@services/resources/SaleAnalyseService'
import Money from '@src/mixins/money'
import ViewModel from '@components/analysis/view'
import Graph from './graph'
import Filters from './filters'
import _ from 'lodash'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

var service = AnalysisService.build()

/**
 * Dashboard-4 component
 */
export default {
  page: {
    title: 'Análises de Venda',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Portlet, ViewModel, Graph, Filters, NewProgressBar },
  mixins: [Money],
  data() {
    return {
      title: 'Análises de Vendas',
      idAnalysys: 0,
      analysis: [],
      solicitation: {},
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Análise de Vendas',
          active: true,
        },
      ],
      totalRows: 10,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 15,
      pageOptions: [15, 50, 100],
      filter: '',
      filterOn: [],
      filters: {},
      sortBy: 'name',
      sortDesc: false,
      columns: [
        { key: 'id', label: '# ID', sortable: true },
        { key: '_sale', label: 'Data/IP', sortable: false },
        { key: 'entity', label: 'Cliente', sortable: false },
        { key: 'entity_id', label: 'Venda', sortable: false },
        { key: '_actions2', label: 'Vendedor' },
        { key: 'reason', label: 'Reason', sortable: false },
        // { key: 'analysed', label: 'Risco da Venda', sortable: false },
        // { key: '_score', label: 'Score Vendedor', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
      obj: {
        product: {
          name: null,
        },
        seller: {
          name: null,
          email: null,
          cellphone: null,
          cpf: null,
        },
        client: {
          name: null,
          email: null,
          cellphone: null,
          cpf: null,
        },
        method: null,
        paid_at: null,
        total: 0,
        reason: null,
        risk_body: {},
      },
    }
  },
  watch: {
    async currentPage() {
      await this.fetchAnalysis(this.filters)
    },
    async perPage() {
      await this.fetchAnalysis(this.filters)
    },
    async filter() {
      await this.debounce()
    },
  },
  async mounted() {
    await this.fetchAnalysis()
  },
  methods: {
    getStatus(status) {
      let r = {}
      if (status) {
        switch (status.toLowerCase()) {
          case 'opened': {
            r = { text: 'Aberto', class: 'status status--opened' }
            break
          }
          case 'in_negociation': {
            r = {
              text: 'Em negociação',
              class: 'status status--in_negociation',
            }
            break
          }
          case 'objection': {
            r = {
              text: 'Objeção',
              class: 'status status--objection',
            }
            break
          }
          case 'lost_trading': {
            r = {
              text: 'Negociação Perdida',
              class: 'status status--lost_trading',
            }
            break
          }
          case 'win': {
            r = {
              text: 'Vencemos',
              class: 'status status--win',
            }
            break
          }
          case '': {
            r = { text: 'list', class: 'is-red' }
            break
          }

          case 'PENDING_payment': {
            r = {
              text: 'Aguardando pagamento',
              class: 'status status--opened',
            }
            break
          }
          case 'paid': {
            r = { text: 'Pago', class: 'status status--in_negociation' }
            break
          }
          case 'abandoned': {
            r = { text: 'Abandonado', class: 'status status--lost_trading' }
            break
          }
          case 'canceled': {
            r = { text: 'Cancelado', class: 'status status--objection' }
            break
          }
          case 'trialing': {
            r = { text: 'Trial', class: 'status status--win' }
            break
          }
          case 'pending_approbation': {
            r = { text: 'Liberação manual', class: 'is-light-blue' }
            break
          }

          case 'pending_refund':
          case 'refund_pending': {
            r = { text: 'Reembolso pendente', class: 'is-warning' }
            break
          }
          case 'refused': {
            r = { text: 'Recusado', class: 'is-red' }
            break
          }
          case 'refunded': {
            r = { text: 'Reembolsado', class: 'is-red' }
            break
          }
          case 'chargedback': {
            r = { text: 'Estorno', class: 'is-warning' }
            break
          }
          case 'delayed': {
            r = { text: 'Em processamento', class: 'is-warning' }
            break
          }
          default: {
            r = { text: status, class: 'status' }
            break
          }
        }
        return r
      } else
        return {
          text: '',
          class: 'status',
        }
    },
    copyLink(value) {
      // Copy link
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$bvToast.toast(
        `Item copiado com sucesso!`,
        {
          title: "Copiado!",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        }
      );
    },
    setColor(number) {
      if (number === 1 || number === 0) {
        return ''
      } else if (number > 2 && number < 5) {
        return 'aberto'
      } else if (number >= 5) {
        return 'fraude'
      } else {
        return ''
      }
    },
    debounce: _.debounce(async function  () {
      await this.fetchAnalysis()
    }, 500),
    async posFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      await this.fetchAnalysis(this.filters);
    },
    async fetchAnalysis(filters = {}) {
      this.loading = true
      this.analysis = []

      var data = {
        per_page: this.perPage,
        page: this.currentPage,
      }

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.filter.length) data.search = this.filter

      await service
        .search(data)
        .then((resp) => {
          this.analysis = resp.data
          this.currentPage = resp.current_page
          this.totalRows = resp.total
          this.total = resp.total
          this.perPage = resp.per_page
          this.loading = false
        })
        .catch((err) => {})
    },
    textMethod(method) {
      let t = ''
      if (method) {
        switch (method.toUpperCase()) {
          case 'CREDIT_CARD': {
            t = 'CARTÃO DE CRÉDITO'
            break
          }
          case 'TWO_CREDIT_CARDS': {
            t = 'DOIS CARTÕES'
            break
          }

          default: {
            t = method
            break
          }
        }
        return t
      } else return method
    },
    async update(data) {
      await service
        .update(data)
        .then(async(resp) => {
          this.$bvModal.hide('modal-view')
          await this.fetchAnalysis(this.filters);
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async accept(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja reportar como Alarme Falso? A venda continuará no Greenn.',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
        inputValidator: (value) => {
          if (value.length <= 10) {
            return "O motivo da fraude deve ter mais de 10 caracteres!";
          }
        }
      }).then(async(result) => {
        if (result.value) {
          let data = {
            id: id,
            status: 'FALSE_ALARM',
          }
          await this.update(data)
        }
      })
    },
    async deny(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja reportar como Fraude? A venda será reembolsada no Greenn, informe o motivo.',
        type: 'error',
        input: "textarea",
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then(async(result) => {
        if (result.value) {
          let data = {
            id: id,
            status: 'FRAUD',
            comment: result.value,
            observation: result.value,
          }

          await this.update(data)
        }
      })
    },
    open(obj) {
      console.log(obj)
      this.idAnalysys = obj.id
      this.obj = obj.sale
      this.obj.risk_body = JSON.parse(obj.sale.antifraud_analysis[0].risk_body)
      this.obj.comment = obj.comment
      this.$bvModal.show('modal-view')
    },
    getLinkConsole(obj) {
      const riskBody = JSON.parse(obj.sale.antifraud_analysis[0].risk_body);
      const idConsole = riskBody[0].caseId;
      return `https://console.signifyd.com/orders/${idConsole}`;
    },
  },
}
</script>
<template>
  <div class="analysis">
    <PageHeader :title="title" :items="items" />

    <!-- filters -->
    <Filters @close="posFilters" />
    <ViewModel :id="idAnalysys" :obj="obj" @accept="accept" @deny="deny" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">
            <!-- Items per page -->
            <div class="col-sm-12 col-md-6">
              <div class="row align-items-center">
                <b-button v-b-modal.modal-filters variant="success" size="sm"
                  >Filtros</b-button
                >

                <div class="col-2 m-0">Mostrar&nbsp;</div>
                <div class="col-3 m-0 p-0">
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </div>
                <div class="col-3 m-0 p-0">&nbsp;por página</div>
              </div>
            </div>
            <!-- End Items per page -->
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div
                v-if="analysis.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="analysis"
                  :fields="columns"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  :filter-included-fields="filterOn"
                >
                  <!-- :filter="filter" -->

                  <template v-slot:cell(id)="data">
                    <p class="text id center"> # {{ data.item.id }}</p>
                    <div
                      v-if="data.item.status === 'FRAUD'"
                      class="tags fraude"
                      >fraude</div
                    >
                    <div
                      v-if="data.item.status === 'FALSE_ALARM'"
                      class="tags alarme"
                      >alarme falso</div
                    >
                    <div
                      v-if="data.item.status === 'PENDING' || data.item.status === null"
                      class="tags aberto"
                      >em Aberto</div
                    >
                  </template>

                  <template v-slot:cell(_sale)="data">
                    <p class="text id">{{
                      data.item.created_at | datetime
                    }}</p>
                    <div
                      v-if="
                        data.item.sale.payment_request &&
                        data.item.sale.payment_request.ip
                      "
                      class="grid-sub"
                    >
                      <!-- <div class="tags" :class="setColor(data.item.count.ip)" v-b-tooltip.hover title="Quantas vezes o IP foi utilizado">{{ data.item.count.ip }}</div> -->
                      <div
                        v-b-tooltip.hover
                        class="subtext pointer"
                        :title="data.item.sale.payment_request.ip"
                        @click="copyLink(data.item.sale.payment_request.ip)"
                        >IP:
                        {{
                          data.item.sale.payment_request.ip.slice(0, 8)
                        }}</div
                      >
                    </div>
                    <div
                      v-if="data.item.sale.method === 'CREDIT_CARD'"
                      class="grid-sub"
                    >
                      <!-- <div class="tags" :class="setColor(data.item.count.card)"  v-b-tooltip.hover title="Quantas vezes o Cartão foi utilizado">{{ data.item.count.card}}</div> -->
                      <div
                        v-if="data.item.sale.fingerprint_card"
                        v-b-tooltip.hover
                        class="subtext pointer"
                        :title="data.item.sale.fingerprint_card"
                        @click="copyLink(data.item.sale.fingerprint_card)"
                        >Cartão:
                        {{
                          data.item.sale.fingerprint_card.slice(0, 8)
                        }}</div
                      >
                    </div>
                    <div
                      v-if="data.item.sale.method === 'TWO_CREDIT_CARD'"
                      class="grid-sub"
                    >
                      <!-- <div class="tags" :class="setColor(data.item.count.card)" v-b-tooltip.hover title="Quantas vezes o Cartão foi utilizado">{{ data.item.count.card}}</div> -->
                      <div
                        v-if="data.item.sale.fingerprint_card"
                        v-b-tooltip.hover
                        class="subtext pointer"
                        :title="data.item.sale.fingerprint_card"
                        @click="copyLink(data.item.sale.fingerprint_card)"
                        >Cartão:
                        {{
                          data.item.sale.fingerprint_card.slice(0, 8)
                        }}</div
                      >
                    </div>
                    <div
                      v-if="data.item.sale.method === 'TWO_CREDIT_CARD'"
                      class="grid-sub"
                    >
                      <!-- <div class="tags" :class="setColor(data.item.count.card)" v-b-tooltip.hover title="Quantas vezes o Cartão foi utilizado">{{ data.item.count.card}}</div> -->
                      <div
                        v-if="data.item.sale.fingerprint_card2"
                        v-b-tooltip.hover
                        class="subtext pointer"
                        :title="data.item.sale.fingerprint_card2"
                        @click="copyLink(data.item.sale.fingerprint_card2)"
                        >Cartão:
                        {{
                          data.item.sale.fingerprint_card2.slice(0, 8)
                        }}</div
                      >
                    </div>
                  </template>

                  <template v-slot:cell(entity)="data">
                    <p v-if="data.item.sale.client" class="text id">{{
                      data.item.sale.client.name
                    }}</p>
                    <div v-if="data.item.sale.client" class="grid-sub">
                      <!-- <div class="tags" :class="setColor(data.item.count.cpf_cnpj)" v-b-tooltip.hover title="Quantas vezes o Documento foi utilizado">{{ data.item.count.cpf_cnpj}}</div> -->
                      <div class="subtext"
                        >CPF/CNPJ:
                        {{ data.item.sale.client.cpf_cnpj }}</div
                      >
                    </div>
                    <div v-if="data.item.sale.client" class="grid-sub">
                      <!-- <div class="tags" :class="setColor(data.item.count.phone)" v-b-tooltip.hover title="Quantas vezes o Telefone foi utilizado">{{ data.item.count.phone}}</div> -->
                      <div class="subtext"
                        >Telefone:{{
                          data.item.sale.client.cellphone
                        }}</div
                      >
                    </div>
                      <div v-if="data.item.sale.client" class="subtext"
                        >Email:{{ data.item.sale.client.email }}</div
                      >
                      <div class="mt-2" v-if="data.item.sale.client"
                        ><a target="_blank" :href="getLinkConsole(data.item)">Ver Análise no SignifyD</a></div
                      >
                  </template>

                  <template v-slot:cell(entity_id)="data">
                    <p v-if="data.item.sale" class="idsale mb-itens"
                      ># {{ data.item.sale.id }}</p
                    >
                    <p
                      v-if="data.item.sale.product"
                      class="subtext mb-itens"
                      >{{ data.item.sale.product.name }}</p
                    >
                    <p
                      v-if="data.item.sale"
                      class="subtext mb-itens"
                      >R$ {{ formatMoney(data.item.sale.amount) }}</p
                    >
                    <p v-if="data.item.sale" class="subtext mb-itens">{{
                      textMethod(data.item.sale.method)
                    }}</p>
                    <p v-if="data.item.sale" class="idsale mb-itens">{{
                      getStatus(data.item.sale.status).text
                    }}</p>
                    <p v-if="data.item.sale" class="mb-itens">{{
                      data.item.sale.created_at | datetime
                    }}</p>
                    <p v-if="data.item.sale" class="mb-itens">{{
                      data.item.sale.amount | datetime
                    }}</p>
                  </template>

                  <template v-slot:cell(_actions2)="data">
                    <p
                      v-if="data.item.sale.seller"
                      class="subtext mb-itens"
                      ><span class="idsale"
                        ># {{ data.item.sale.seller.id }} -</span
                      >
                      {{ data.item.sale.seller.name }}</p
                    >
                    <p
                      v-if="data.item.sale.seller"
                      class="subtext mb-itens"
                      >{{ data.item.sale.seller.email }}</p
                    >
                    <p
                      v-if="data.item.sale.seller"
                      class="subtext mb-itens"
                      >{{ data.item.sale.seller.cellphone }}</p
                    >
                  </template>

                  <template v-slot:cell(analysed)="data">
                   
                    <NewProgressBar :type="'RiskScore'" :valor="data.item.sale.risk_score"/>
                  </template>

                  <template v-slot:cell(reason)="data">
                    {{ data.item.comment }}
                  </template>

                  <template v-slot:cell(_score)="data">
                    <NewProgressBar :type="'SellerScore'" :valor="data.item.avg_user_scores"/>

                  </template>

                  <template v-slot:cell(_actions)="data">
                    <b-dropdown v-if="data.item.status === 'PENDING' || data.item.status === null"  right>
                      <template v-slot:button-content>
                        <div class="button-action">
                          <svg
                            width="14"
                            height="16"
                            viewBox="0 0 14 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.66667 1L1 9.04706H7L6.33333 14.4118L13 6.36471H7L7.66667 1Z"
                              stroke="#2133D2"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </template>
                      <b-dropdown-item @click="deny(data.item.id)"
                        >Reportar como Fraude</b-dropdown-item
                      >
                      <!-- <b-dropdown-item>Fraude detectada</b-dropdown-item> -->
                      <b-dropdown-item @click="accept(data.item.id)"
                        >Reportar como Alarme Falso</b-dropdown-item
                      >
                    </b-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-if="analysis.length > 0" class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div
            v-if="analysis.length == 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem requisições pendentes.
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.actions {
}

p,
span {
  font-family: 'Montserrat';
  font-style: normal;
  margin: 0;
}

.text {
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: #333333;
  font-weight: 600;
}

.subtext {
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: #81858e;
  font-weight: 400;
}

.id {
  margin-bottom: 10px;
}

.mb-itens {
  margin-bottom: 7px;
}

.center {
  text-align: center;
}

.aberto {
  color: #2133d2 !important;
  background: rgba(33, 51, 210, 0.1) !important;
}

.fraude {
  color: #f41a42 !important;
  background: rgba(244, 26, 66, 0.1) !important;
}

.alarme {
  color: #ff9900 !important;
  background: rgba(255, 153, 0, 0.1) !important;
}

.tags {
  padding: 3px 0px;
  text-align: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2px;
  border-radius: 2px;
  background: #f7f7f7;
  color: #333333;
  height: fit-content;
}

.grid-sub {
  display: grid;
  grid-template-columns: 25px 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.idsale {
  color: #2133d2;
  font-weight: 600;
}

.button-action {
  width: 35px;
  height: 35px;
  background: rgba(33, 51, 210, 0.1);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pointer{
  cursor: pointer;
}
</style>

